import { useMedia } from '@/features/ui/hooks/useMedia.js'

export function useBreakpoint() {
  const isTablet = useMedia('(max-width: 1024px)')
  const isMobile = useMedia('(max-width: 768px)')

  return {
    isMobile,
    isTablet,
  }
}
